import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import { Box } from "@mui/system";
import { useState } from "react";
import { TabWithCount } from "../SocialCase/SocialCase";
import { a11yProps } from "../Tabs.MUI/Tabs.interface";
import PointOfSaleIcon from "@mui/icons-material/PointOfSale";
import ElectricRickshawIcon from "@mui/icons-material/ElectricRickshaw";
import { NotificationButton } from "../Tabs.MUI/tabs.styled";
import Bell from "../../assets/Bell.svg";
import { TabPanel } from "../MoveInRegistration/MoveInRegistration";
import Notifications from "../../components/Notifications/Notifications";
import WWPRNocTab from "../../components/consultationTabs.tsx/WWPRTabs";
import General from "../../stores/GeneralStore";
const ConsultationTabs = () => {
  const [value, setValue] = useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  return (
    <>
      <Box sx={{ width: "100%", paddingTop: ".8rem" }}>
        <Box
          sx={{
            borderBottom: 1,
            borderColor: "divider",
            display: "flex",
            background: "#eee",
            width: "100%",
          }}
        >
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="basic tabs example"
            sx={{ alignSelf: "flex-end", width: "80%" }}
            variant="scrollable"
            scrollButtons
            allowScrollButtonsMobile
          >
            <Tab
              label={
                <TabWithCount justifyContent="center">
                  <PointOfSaleIcon />
                 
                  {General?.codeLabels["cm_wwpr_nocs"]?.label !== undefined ? General?.codeLabels["cm_wwpr_nocs"]?.label : " WWPR NOCs"}

                </TabWithCount>
              }
              {...a11yProps(0)}
              sx={{
                background: "#101e8e",
                color: "#fff",
                margin: "0.2rem",
                marginBottom: "0",
                width: "18%",
              }}
            />
            <Tab
              label={
                <TabWithCount justifyContent="center">
                  <ElectricRickshawIcon />
                 
                  {General?.codeLabels["cm_excavation_nocs"]?.label !== undefined ? General?.codeLabels["cm_excavation_nocs"]?.label : "EXCAVATION NOCs"}

                </TabWithCount>
              }
              {...a11yProps(1)}
              sx={{
                background: "#101e8e",
                color: "#fff",
                margin: "0.2rem",
                marginBottom: "0",
                width: "18%",
              }}
            />
          </Tabs>
          <NotificationButton
            onClick={() => {
              setValue(2);
            }}
          >
            <img src={Bell} alt="" />
            <div>1</div>
          </NotificationButton>
        </Box>
        <Box
          sx={{
            margin: "auto",
            display: "flex",
            flexDirection: "column",
            background: "#eee",
            width: "100%",
          }}
        >
          <TabPanel
            value={value}
            index={0}
            width="100%"
            background="#e7e9f8"
            padding={10}
          >
            <WWPRNocTab />
          </TabPanel>
          <TabPanel value={value} index={1}>
            second tab
          </TabPanel>
        </Box>
        <TabPanel value={value} index={2}>
          <Notifications />
        </TabPanel>
      </Box>
    </>
  );
};
export default ConsultationTabs;
